<template>
  <div v-if="info.storeInfo" class="detail-color">
    <div class="item-detail-show">
      <div class="item-detail-left">
        <div class="item-detail-big-img">
          <!-- <img :src="bigImage" alt=""> -->
          <pic-zoom :url="bigImage" :scale="2.5"></pic-zoom>
        </div>
        <div class="item-detail-img-row">
          <div class="img-box">
            <div
              class="item-detail-img-small"
              v-for="(item, index) in info.storeInfo.slider_image"
              :key="index"
              @mouseover="showBigImg(item)"
            >
              <img :src="item" alt="" />
            </div>
          </div>
        </div>
        <div class="collect" @click="collectProduct(info.storeInfo.id)">
          <Icon
            type="star"
            class="star"
            :class="info.storeInfo.userCollect ? 'on' : ''"
          ></Icon>
          <span>收藏宝贝</span>
        </div>
      </div>
      <div class="item-detail-right">
        <div class="item-detail-title">
          <p>
            {{ info.storeInfo.store_name }}
          </p>
        </div>
        <div class="price-box">
          <div class="now-price">
            <div>正常价</div>
            <div>
              ￥<span>{{ info.storeInfo.price }}</span>
            </div>
          </div>
          <div class="vip-price" v-if="info.storeInfo.ot_price !== 0">
            <div>原价</div>
            <div><span>￥</span>{{ info.storeInfo.ot_price }}</div>
          </div>
        </div>
        <div class="attr-box">
          <div class="attr-name">
            <div>通用名</div>
            <div>{{ info.storeInfo.general_name }}</div>
          </div>
          <div class="attr-name">
            <div>生产商</div>
            <div>{{ info.storeInfo.Authorized_holder }}</div>
          </div>
          <div class="attr-name">
            <div class="country">国家</div>
            <div>{{ info.storeInfo.country }}</div>
          </div>
        </div>
        <div
          class="item-select"
          v-for="(item, index) of info.productAttr"
          :key="index"
        >
          <div class="item-select-title">
            <p>{{ item.attr_name }}</p>
          </div>
          <div class="item-select-column">
            <div
              class="item-select-row"
              v-for="(items, indexs) in item.attr_value"
              :key="indexs"
            >
              <div
                class="item-select-box"
                @click="selectAttr(index, indexs)"
                :class="item.index === indexs ? 'item-select-box-active' : ''"
              >
                <div class="item-select-intro">
                  <p>{{ items.attr }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="add-buy-car-box">
          <div class="add-buy-car">
            <span class="num">数量</span>
            <div class="input-box">
              <input type="search" v-model="count" @input="changeNum()" />
              <div class="choose-box">
                <div class="add" @click="addNum">
                  <Icon type="plus-round"></Icon>
                </div>
                <div class="del" @click="delNum">
                  <Icon type="minus-round"></Icon>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-box">
            <Button
              type="error"
              size="large"
              @click="goToBuy()"
              class="goto-buy btn"
              >立即购买</Button
            >
            <Button
              type="error"
              size="large"
              @click="addShoppingCartBtn()"
              class="btn goto-cart"
              ><Icon type="android-cart" class="cart"></Icon>加入购物车</Button
            >
          </div>
        </div>
        <!-- <div class="tip-box">
          本品为处方药，您成功预定后，药剂师会进行审核，根据处方审核结果主动与您联系。
          （如需协助请拨打 <span>+00853-65885387</span>）
        </div> -->
      </div>
      <Modal v-model="Contraindications" title="禁忌症提醒" @on-ok="OK">
        <p v-html="info.storeInfo.contraindications"></p>
      </Modal>
    </div>
    <ShoppingList :showShopping="showShopping"></ShoppingList>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import {
  postCartAdd,
  getCartList,
  getCollectDel,
  getCollectAdd,
  getUser
} from "@api/user";

import PicZoom from "vue-piczoom";
import ShoppingList from "@/components/pc/goodsDetail/ShoppingList";
export default {
  name: "ShowGoods",
  props: ["info"],
  components: {
    PicZoom,
    ShoppingList
  },
  data() {
    return {
      price: 0,
      count: 1,
      imgIndex: 0,
      b_image: "",
      productSelect: {},
      uniqueId: "",
      attrCart: "", // 商品选中的属性
      collectActive: false,
      Contraindications: false,
      chooseType: 1,
      showShopping: false,
      showAlert: false,
      userInfo: {}
    };
  },
  watch: {
    info() {
      if (this.info) {
        const value = [];
        this.info.productAttr.forEach((element, index1) => {
          element.index = 0;
          value.push(this.info.productAttr[index1].attr_values[0]);
        });
        const selectID = value.sort().join(",");
        this.attrCart = selectID;
        for (var i in this.info.productValue) {
          if (selectID === i) {
            this.uniqueId = this.info.productValue[i].unique;
          }
        }
      }
    }
  },
  created() {
  /*
    getUser()
      .then(res => {
        this.userInfo = res.data;
      })
      .catch(err => {
        console.log(err.msg);
      });
  */
  },
  computed: {
    // 药品主图的放大
    bigImage() {
      if (this.b_image) {
        return this.b_image;
      }
      return this.info.storeInfo.image;
    }
  },
  methods: {
    ...mapActions(["addShoppingCart"]),
    ...mapMutations(["SET_SHOPPING_CART"]),
    // 主图图片
    showBigImg(item) {
      this.b_image = item;
    },
    addShoppingCartBtn() {
      if (this.showAlert) {
        this.addBuyBtn(0);
        return;
      }
      if (!this.info.storeInfo.contraindications) {
        this.addBuyBtn(0);
      } else {
        this.Contraindications = true;
        this.chooseType = 0;
        this.showAlert = true;
      }
    },
    goToBuy() {
      if (
        this.userInfo.spread_uid == 0 &&
        this.userInfo.certification_type == 1
      ) {
        return this.$dialog.toast({
          mes: "請聯繫醫院購買"
        });
      }
      if (this.showAlert) {
        this.addBuyBtn(1);
        return;
      }
      if (!this.info.storeInfo.contraindications) {
        this.addBuyBtn(1);
      } else {
        this.Contraindications = true;
        this.chooseType = 1;
        this.showAlert = true;
      }
    },
    addBuyBtn(buyTpye) {
      const data = {
        cartNum: this.count,
        new: buyTpye, // 购买类型 0加入购物车 1立即购买
        productId: this.info.storeInfo.id,
        uniqueId: this.uniqueId
      };
      postCartAdd(data)
        .then(
          res => {
            if (res.status === 200) {
              this.showShopping = true;

              if (buyTpye === 0) {
                getCartList().then(res => {
                  this.SET_SHOPPING_CART(res.data.valid);
                });
                // this.$Modal.confirm({
                //   content: "<h2>商品已成功加入购物车</h2>",
                //   cancelText: "关闭",
                //   okText: "前往购物车",
                //   onOk: () => {
                //     this.$router.push("/shoppingCart");
                //   }
                // });
              } else {
                const cartId = res.data.cartId;
                this.$router.push("/order/" + cartId);
              }
            }
          },
          err => {
            this.$Modal.warning({
              content: err.msg
            });
          }
        )
        .catch(err => {
          this.$Modal.warning({
            content: err.msg
          });
        });
    },
    // 选择属性
    selectAttr(NewIndex, indexs) {
      const midProductAttr = this.info.productAttr[NewIndex];
      midProductAttr.index = indexs;
      this.info.productAttr.splice(NewIndex, 1, midProductAttr);
      // 重新获取属性id
      const value = [];
      this.info.productAttr.forEach((element, index1) => {
        value.push(this.info.productAttr[index1].attr_values[element.index]);
      });
      const selectID = value.sort().join(",");
      for (var i in this.info.productValue) {
        if (selectID === i) {
          this.uniqueId = this.info.productValue[i].unique;
          this.info.storeInfo.price = this.info.productValue[i].price;
        }
      }
    },
    changeNum() {
      const stock = this.info.storeInfo.stock;
      if (this.count > stock) {
        this.count = 1;
        this.$Modal.warning({
          content: "你输入的值超过库存量"
        });
      }
    },
    delNum() {
      if (this.count !== 1) {
        this.count--;
      }
    },
    addNum() {
      const stock = this.info.storeInfo.stock;
      if (this.count < stock) {
        this.count++;
      }
    },
    // 收藏商品
    collectProduct(id) {
      if (this.info.storeInfo.userCollect) {
        getCollectDel(id, "product").then(() => {
          this.$Message.success("取消收藏成功");
          this.info.storeInfo.userCollect = false;
        });
      } else {
        getCollectAdd(id, "product").then(() => {
          this.$Message.success("添加收藏成功");
          this.info.storeInfo.userCollect = true;
        });
      }
    },
    OK() {
      this.Contraindications = false;
      this.addBuyBtn(this.chooseType);
    }
  }
};
</script>

<style lang="stylus" scoped>
.item-detail-big-img >>> .magnifier-box.vertical img
  width 100%

.detail-color
  background #f4f7f7
  .item-detail-show
    width 1200px
    margin 0 auto 15px
    display flex
    flex-direction row
    background-color #fff
    padding 15px
    .item-detail-left
      width 400px
      margin-right 30px
      .item-detail-big-img
        width 400px
        height 400px
        box-shadow 0px 0px 8px #ccc
        cursor pointer
      .item-detail-img-row
        margin-top 15px
        .img-box
          white-space nowrap
          overflow-x auto
          .item-detail-img-small
            width 68px
            height 68px
            box-shadow 0px 0px 8px #ccc
            cursor pointer
            display inline-block
            margin-right 8px
            &:last-child
              margin-right 0
            img
              width 100%
              height 100%
      .collect
        margin-top 5px
        cursor pointer
        .star
          font-size 18px
          color rgb(119, 119, 119)
          &.on
            color #e93323
        &:hover .star
          animation up 1s linear
        >span
          font-size 14px
          color rgb(119, 119, 119)
    .item-detail-right
      display flex
      flex-direction column
      margin-top 10px
      font-family '宋体'
      .item-detail-title
        p
          color #333
          width 600px
          font-size 24px
          font-weight 700
          overflow hidden
          text-overflow ellipsis
          white-space nowrap
          height 70px
      .price-box
        font-size 14px
        .now-price
          display flex
          margin-bottom 10px
          div:first-child
            color #999
            margin-right 40px
            letter-spacing 4px
          div:last-child
            color #fa372e
            line-height 4px
            font-weight 700
            font-size 18px
            font-family 'Microsoft yahei'
            span
              font-size 40px
        .vip-price
          display flex
          div:first-child
            color #999
            margin-right 40px
            letter-spacing 4px
          div:last-child
            color #fa372e
            font-weight 700
            font-size 18px
            line-height 24px
            font-family 'Microsoft yahei'
      .attr-box
        margin-top 25px
        .attr-name
          display flex
          font-size 14px
          margin-bottom 5px
          div:first-child
            color #999
            margin-right 40px
            letter-spacing 4px
            width 54px
          .country
            text-align-last:justify;
      .item-select
        display flex
        flex-direction row
        margin-top 15px
        .item-select-title
          color #999
          font-size 14px
          margin-right 40px
          line-height 38px
          width 54px
          letter-spacing 4px
          text-align-last justify
        .item-select-column
          display flex
          .item-select-row
            display flex
            flex-direction row
            margin-bottom 8px
            .item-select-box
              display flex
              flex-direction row
              align-items center
              padding 5px
              margin-right 8px
              background-color #fff
              border 0.5px solid #ccc
              cursor pointer
              &:hover
                border 0.5px solid #e3393c
              &.item-select-box-active
                border 0.5px solid #ff5c4c
                position relative
                &:after
                  content ''
                  display inline-block
                  position absolute
                  width 13px
                  height 13px
                  background #ff5c4c
                  background-image url(../../../assets/pc/images/pay/active.png)
                  background-size 100% 100%
                  right -1px
                  bottom 0
                  border-radius 0 0 4px 0
              .item-select-intro
                p
                  margin 0px
                  padding 5px
      .add-buy-car-box
        width 100%
        margin-top 5px
        display flex
        align-items center
        .add-buy-car
          margin-top 15px
          margin-bottom 10px
          display flex
          align-items center
          margin-right 40px
          .num
            font-size 14px
            color #999
            margin-right 40px
            letter-spacing 4px
            width 54px
            text-align-last justify
          .input-box
            display flex
            justify-content space-between
            border 1px solid #dcdcdc
            line-height 28px
            border-radius 2px
            width 50px
            input
              background none
              border none
              width 33px
              text-align center
              color #3C3C3C
              font-size 14px
            .choose-box
              flex 1
              .del,.add
                line-height 16px
                height 16px
                text-align center
                font-size 11px
                background #ededed
                cursor pointer
                border-left 1px solid #dcdcdc
              .add
                border-bottom 1px solid #dcdcdc
        .btn-box
          transform translateY(3px)
          font-family 'Microsoft yahei'
          .btn
            padding 6px 25px
            font-size 16px
          .goto-buy
            color #fff
            border-color #ffc105
            background #ffc105
            margin-right 10px
          .goto-cart
            background #fd3d3b
            .cart
              font-size 18px
              margin-right 10px
              color #fff
      .tip-box
        font-size 12px
        margin-left 95px
        margin-top 10px
        width 60%
        span
          color #fa372e
          letter-spacing 1px
@keyframes up
  0%
    transform translateY(0)
  50%
    transform translateY(-10px)
  100%
    transform translateY(0)
</style>
